// Register the service worker and wire aggressive update behaviour:
// poll for updates on load / focus / visibility / interval, and auto-reload
// as soon as the worker reports fresh content.

const UPDATE_INTERVAL_MS = 60_000;

export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;
  if (!import.meta.env.PROD) return;

  window.addEventListener('load', () => {
    // Capture this before registering: if there is no existing controller,
    // the first clients.claim() will fire controllerchange for a page that
    // just loaded — we must not reload in that case.
    const hadController = !!navigator.serviceWorker.controller;

    void navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        const checkForUpdate = () => {
          registration.update().catch(() => {});
        };

        window.setInterval(checkForUpdate, UPDATE_INTERVAL_MS);
        window.addEventListener('focus', checkForUpdate);
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') checkForUpdate();
        });
      })
      .catch(() => {});

    let reloading = false;
    const reloadOnce = () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    };

    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'sw-content-updated') reloadOnce();
    });

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (hadController) reloadOnce();
    });
  });
}
